import React, { useContext, useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AuthContext } from "../contexts/AuthContext.js";
import "./styles/Navbar.css";

const NavBar = () => {
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => {
    setIsDropdownOpen(prev => !prev);
  };

  const handleLogout = () => {
    logout();
    setIsDropdownOpen(false);
    navigate("/");
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("pointerdown", handleClickOutside);
    return () => document.removeEventListener("pointerdown", handleClickOutside);
  }, []);

  return (
    <nav className="navbar">
      <div className="navbar-logo">
        <Link to="/">
          <img
            src="/vyralnewslogo_1787523012934.png"
            alt="VyralNews — Where Trending Meets Truth"
            className="navbar-logo-img"
          />
        </Link>
      </div>

      <div className="navbar-links">
        {user ? (
          <div className="nav-dropdown" ref={dropdownRef}>
            <button type="button" className="nav-dropdown-label" aria-expanded={isDropdownOpen} onClick={toggleDropdown}>
              {user.username} ▾
            </button>
            {isDropdownOpen && (
              <div className="nav-dropdown-content">
                {user.role === "admin" && (
                  <>
                    <Link to="/admin/dashboard">Dashboard</Link>
                    <Link to="/admin/articles">Admin Articles</Link>
                    <Link to="/admin/pricing">Pricing</Link>
                  </>
                )}
                {(user.role !== "freemium") && (
                  <Link to="/portal/articles">Articles Portal</Link>
                )}
                {user.role === "journalist" && <Link to="/journal/home">Journal Home</Link>}
                {user.role === "reporter" && <Link to="/report/home">Report Home</Link>}
                <Link to="/user/profile">Profile</Link>
                <Link to="/user/settings">Settings</Link>
                <button onClick={handleLogout} className="logout-btn">
                  Logout
                </button>
              </div>
            )}
          </div>
        ) : (
          <div className="nav-dropdown" ref={dropdownRef}>
            <button type="button" className="nav-dropdown-label" aria-expanded={isDropdownOpen} onClick={toggleDropdown}>
              Account ▾
            </button>
            {isDropdownOpen && (
              <div className="nav-dropdown-content">
                <Link to="/login">Login</Link>
                <Link to="/signup">Sign Up</Link>
              </div>
            )}
          </div>
        )}
      </div>
    </nav>
  );
};

export default NavBar;
